// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1-26J","insightsList":"newBusinessInsightsMenu_insightsList__3rUnQ","active":"newBusinessInsightsMenu_active__3-of1"};